import * as AppState from '../../../../../store/app.state';
import * as academicUnitsStatisticsActions from '../action/academic-units-statistics.actions';
import { createReducer } from '@ngrx/store';
import { on } from '@ngrx/store';

/**
 * subject reducer used to updated store values based on certain action.
 */

/**
 * State interface extends App state State and add user state to the main state.
 */
export interface State extends AppState.State {
   statisticsOverview: statisticsOverviewState;
}

/**
 * An SubjectState interface, which represents the blueprint of the User State.
 */
export interface statisticsOverviewState {
   statisticsOverview: any;
   errorMessage: string;
}

/**
 * SubjectState initial state.
 */
export const initialState: statisticsOverviewState = {
   statisticsOverview: null,
   errorMessage: null,
};

/**
 * Subject Reducer used to update the state upon Subject actions.
 */
export const statisticsOverviewReducer = createReducer(
   initialState,
   /**
    * On loadSubjectsDetailsSuccess action updated current state with the following properties.
    */
   on(
      academicUnitsStatisticsActions.overviewStatisticsSuccess,
      (state, action): statisticsOverviewState => {
         return {
            ...state,
            statisticsOverview: action.data,
         };
      }
   ),

   /**
    * On loadSubjectsDetailsFailure action updated current state with the following properties.
    */
   on(
      academicUnitsStatisticsActions.overviewStatisticsFailure,
      (state, action): statisticsOverviewState => {
         return {
            ...state,
            errorMessage: action.error,
         };
      }
   )
);
